import { useLocation } from "react-router-dom";
import { usePageMeta } from "./usePageMeta";

const SITE_DESC =
  "Eugénie Larrivée · Sexologue & psychothérapeute, entrepreneure à impact social et vulgarisatrice. Apaiser les conversations les plus délicates.";

const META = {
  "/": {
    title: "Eugénie Larrivée · On peut en parler",
    description: SITE_DESC,
  },
  "/eugenie": {
    title: "Eugénie",
    description:
      "Sexologue psychothérapeute, entrepreneure à impact social et vulgarisatrice : parcours, mission et convictions d'Eugénie Larrivée.",
  },
  "/clinique": {
    title: "Clinique · Sexothérapie et psychothérapie",
    description:
      "Accompagnement en sexologie et psychothérapie avec Eugénie Larrivée : approches, déroulement d'une démarche et réponses à vos questions.",
  },
  "/conversations": {
    title: "Conversations · La plateforme éditoriale",
    description:
      "Des idées, des questions et des connaissances pour mieux comprendre la sexualité, les relations et ce qui nous relie.",
  },
  "/medias": {
    title: "Médias",
    description:
      "Eugénie Larrivée dans les médias : télévision, radio (102,7 Rouge), presse et balados. Espace presse, bios et dossier de presse.",
  },
  "/conferences": {
    title: "Conférences",
    description:
      "Invitez Eugénie Larrivée : conférences et formations en santé sexuelle, relations humaines et entrepreneuriat social.",
  },
  "/projets": {
    title: "Projets · Sexualis, Fesses & Tendresse, Avec doigté !",
    description:
      "Les projets d'entrepreneuriat social d'Eugénie Larrivée : Sexualis, Fesses & Tendresse et le podcast Avec doigté !",
  },
  "/contact": {
    title: "Contact",
    description:
      "Écrire à Eugénie Larrivée : une question, une invitation média, une conférence ou une collaboration.",
  },
  "/ressources": {
    title: "Ressources d'aide",
    description:
      "Lignes d'écoute et ressources d'aide au Québec : 9-8-8, Info-Santé 811, SOS violence conjugale, Tel-Jeunes et plus.",
  },
  "/confidentialite": {
    title: "Politique de confidentialité et mentions légales",
    description:
      "Comment vos renseignements personnels sont protégés sur ce site (Loi 25) et mentions légales.",
  },
};

/**
 * Applique les métadonnées SEO (titre, description, canonique, Open Graph)
 * selon la route courante. Les pages d'articles gèrent leurs propres métadonnées.
 */
export default function RouteMeta() {
  const { pathname } = useLocation();
  const isArticle = pathname.startsWith("/conversations/") && pathname !== "/conversations";
  const meta = isArticle ? null : META[pathname] || META["/"];
  usePageMeta(meta);
  return null;
}
